import React, { useEffect, useState } from 'react';
import { Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { FilterMenu } from './FilterMenu';
import { FiltersEnum, FiltersType } from '@marketing-site/api/careers/apiSlice';

export type ActiveFilter = {
  key: FiltersEnum;
  value: string | null;
};

type JobsFiltersProps = {
  filters: FiltersType;
  onChange: (filter: ActiveFilter) => void;
};

export const JobsFilters = ({ filters, onChange }: JobsFiltersProps) => {
  return (
    <>
      <Stack gap={'16px'}>
        <Typography
          variant="h4"
          fontSize={16}
          lineHeight={1.25}
          fontWeight={600}
        >
          Filters:
        </Typography>
        <Stack direction={{ mobile: 'column', desktop: 'row' }} gap={150}>
          {Object.keys(filters).map((key, idx) => {
            return (
              <FilterMenu
                label={key as FiltersEnum}
                options={filters[key]}
                onSelect={onChange}
                key={`${key}-${idx}`}
              />
            );
          })}
        </Stack>
      </Stack>
    </>
  );
};
